<template>
  <div>
    <v-text-field
      v-if="data.class === 'text'"
      v-bind="data.attrs"
      :label="data.text"
      v-model="data.value"
      :hint="data.placeholder"
      persistent-hint
      :hide-details="!(!!data.placeholder)"
    ></v-text-field>
    <v-text-field
      v-else-if="data.class === 'password'"
      :label="data.text"
      v-model="data.value"
      :hint="data.placeholder"
      v-bind="data.attrs"
      persistent-hint
      :hide-details="!(!!data.placeholder)"
      type="password"
    ></v-text-field>
    <v-text-field
      v-else-if="data.class === 'email'"
      :label="data.text"
      v-model="data.value"
      :hint="data.placeholder"
      v-bind="data.attrs"
      persistent-hint
      :hide-details="!(!!data.placeholder)"
      :rules="[rules.email]"
      ref="input"
      text-error="Geçersiz email"
    ></v-text-field>
    <v-text-field
      v-else-if="data.class === 'number'"
      :label="data.text"
      v-model="data.value"
      :hint="data.placeholder"
      v-bind="data.attrs"
      persistent-hint
      :hide-details="!(!!data.placeholder)"
      :rules="[rules.number]"
      ref="input"
      text-error="Sadece rakam içerebilir"
    ></v-text-field>
    <v-text-field
      v-else-if="data.class === 'url'"
      :label="data.text"
      v-model="data.value"
      :hint="data.placeholder"
      v-bind="data.attrs"
      persistent-hint
      :hide-details="!(!!data.placeholder)"
      :rules="[rules.url]"
      ref="input"
      text-error="Lütfen geçerli bir url giriniz"
    ></v-text-field>
    <v-menu
      v-else-if="data.class === 'datepicker'"
      v-model="datePicker.datePickerMenu"
      ref="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="datePicker.dateFormatted"
          :label="data.text"
          :hint="data.placeholder"
          persistent-hint
          :hide-details="!(!!data.placeholder)"
          readonly
          v-bind="{...attrs, ...data.attrs}"
          v-on="on"
          @blur="datePicker.date = parseDate(datePicker.dateFormatted)"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="datePicker.date"
        ref="picker"
        :max="new Date().toISOString().substr(0, 10)"
        min="1950-01-01"
        @change="datePickerSave"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "TextField",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: vm => ({
    text: {
      errorText: ""
    },
    datePicker: {
      datePickerMenu: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
    },
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || vm.text.errorText;
      },
      number: value => {
        const pattern = /^\d*(\.\d+)?$/;
        return pattern.test(value) || vm.text.errorText;
      },
      url: value => {
        const pattern =
          /^([w]{3}\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
        return pattern.test(value) || vm.text.errorText;
      }
    }
  }),
  methods: {
    datePickerSave(date) {
      this.$refs.menu.save(date);
      this.data.value = date;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  },
  created() {
    // if (this.data.type === "datepicker")
    //   this.data.value = new Date().toISOString().substr(0, 10);
  },
  mounted() {
    if (this.$refs.input)
      this.text.errorText = this.$refs.input.$attrs["text-error"];
  },
  watch: {
    "datePicker.date"() {
      this.datePicker.dateFormatted = this.formatDate(this.datePicker.date);
    }
  }
};
</script>

<style>
</style>